<template>
    <EditEmployee/>
</template>

<script>
import EditEmployee from '../components/EditEmployee.vue';
export default {
    components: {
        EditEmployee
    }
};
</script>